export default "__VITE_ASSET__pITSNpbQ__"